export default __webpack_public_path__ + "static/media/logo-vai.53d598c7.svg";